import { Component } from '@angular/core';
import { soundpostProcessingErrorEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Processing Errors') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostprocessingerror-form',
    templateUrl: './soundpostprocessingerror.form.component.html'
})
export class soundpostProcessingErrorFormComponent extends BaseFormComponent {
    public record!: soundpostProcessingErrorEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

